import { createApp, type App } from 'vue';
import AntDesignVue from 'ant-design-vue';
import LkMobileNoticeModal from './lk-mobile-notice-modal.vue';

const MOUNT_ID = 'lk-mobile-notice-vue';

let lkMobileNoticeApp: App<Element> | null = null;
let currentMountEl: HTMLElement | null = null;

function ensureMountElement(root?: ParentNode): HTMLElement {
  const scope = root instanceof Element ? root : document;
  const existing =
    (scope instanceof Element
      ? scope.querySelector<HTMLElement>(`#${MOUNT_ID}`)
      : null) ?? document.getElementById(MOUNT_ID);

  if (existing) return existing;

  const mountEl = document.createElement('div');
  mountEl.id = MOUNT_ID;

  const container =
    (root instanceof Element ? root : null)?.querySelector('.personal-area, .lk-page') ??
    document.querySelector('.personal-area, .lk-page') ??
    document.body;

  container.appendChild(mountEl);
  return mountEl;
}

export function initLkMobileNotice(root?: ParentNode): void {
  destroyLkMobileNotice();

  const mountEl = ensureMountElement(root);
  mountEl.innerHTML = '';

  const app = createApp(LkMobileNoticeModal);
  lkMobileNoticeApp = app;
  app.use(AntDesignVue).mount(mountEl);
  currentMountEl = mountEl;
}

export function destroyLkMobileNotice(): void {
  if (!lkMobileNoticeApp || !currentMountEl) return;

  lkMobileNoticeApp.unmount();
  currentMountEl.innerHTML = '';
  currentMountEl.remove();
  lkMobileNoticeApp = null;
  currentMountEl = null;
}
